import React, { Component } from 'react';
import '../assets/css/Login/redeem.css'
import { APICaptcha,APIRedeemCard, APIValid } from '../api/redeem'
import { Form, Input, Button,Toast, Card, Divider, Space, TextArea} from 'antd-mobile'
import img from '../assets/image/banner2.jpg'

/** 样式 */
// var loginTopBg = {height: '300px',background:'#3677ea'};

class Redeem extends Component {
    constructor(props) {
        super(props)
        this.state = { 
            number: "", 
            password: "",
            address:'',
            person:'',
            phone:'',
            remark: '',
            verify:'',
            key:'',
            captcha:'',
            formDisable:true,
            notification:''
        }
    }
    componentDidMount(){
      this.getCaptcha()
      this.checkDate()
    }
    setNumber(value) {
        this.setState({ 
            number: value
        })
    }
    setPassword(value) {
        this.setState({
            password: value
        })
    }
    setAddress(value) {
        this.setState({ 
            address: value
        })
    }
    setPerson(value) {
        this.setState({
            person: value
        })
    }
    setPhone(value) {
        this.setState({
            phone: value
        })
    }
    setRemark(value) {
        this.setState({
            remark: value
        })
    }
    setVerify(value) {
        this.setState({
            verify: value
        })
    }

    login() {
        console.log(this.state);
        //发起请求
        APIRedeemCard({
            number: this.state.number,
            password: this.state.password,
            address: this.state.address,
            person: this.state.person,
            phone: this.state.phone,
            remark: this.state.remark,
            verify: this.state.verify,
            key: this.state.key
        }).then((res) => {
            if(res.data.code===0){
                Toast.show({
                    icon: 'success',
                    content: '兑换成功',
                })
                // this.props.history.push({ pathname: '/index/home' })
            }else{
                Toast.show({
                    icon: 'fail',
                    content: res.msg,
                })
            }
            
        })
    }
    getCaptcha(){
        APICaptcha({}).then(res => {
            if(res.data.code == 0){
                this.setState({
                    captcha: res.data.data.captcha,
                    key: res.data.data.key
                })
            }else{
                Toast.show({
                    icon: 'fail',
                    content: res.msg,
                })
            }
        })
    }

    checkDate(){
        APIValid({}).then(res => {
            console.log(res)
            if(res.data.code == 0){
                if(res.data.data.value == 1){
                    this.setState({
                        formDisable: false,
                        notification: res.data.data.value2
                    })
                }else{
                    this.setState({
                        formDisable: true,
                        notification: res.data.data.value2||'系统正在升级，暂时无法兑换蟹卡，请于两个工作日后重新兑换'
                    })
                }
            }
        })

        //以下为写死日期，到日期后停止兑换
        // const today = new Date();
        // const year = today.getFullYear();
        // const month = String(today.getMonth() + 1).padStart(2, '0');
        // const day = String(today.getDate()).padStart(2, '0');

        // var t = year + '-' + month + '-' + day;
        
        // if(t >= '2024-12-15'){
        //     this.setState({
        //         formDisable: true
        //     })
        // }
    }

    nextTo(){
        this.props.history.push({ pathname: '/Wuliu' })
    }
   
    render() {
        return (
            <div className='login'>
                    <img src={img} width={'100%'}/>
                {/* <div className='login-top-bg' style={loginTopBg}> */}
                {/* </div> */}
                    <Card>
                        <div style={{'color':'red','font-size':'18px','margin':'5px 0px'}}>
                            {this.state.notification}
                        </div>
                    </Card>
               
                <Form  disabled={this.state.formDisable} layout="horizontal" onFinish={() => { this.login() }}
                    footer={
                        <Button disabled={this.state.formDisable} block type='submit' color='primary' size='large'>
                            立即兑换
                        </Button>
                    }
                >
                    <>
                        <Form.Item
                            name='username'
                            label='提货号码'
                            rules={[{ required: true, message: '请填写提货号码' }]}
                        >
                            <Input placeholder='请输入提货号码' value='this.state.username' onChange={(e) => {
                                this.setNumber(e)
                            }} />
                        </Form.Item>
                        <Form.Item
                            name='password'
                            label='提货密码'
                            rules={[{ required: true, message: '请填写提货密码' }]}
                        >
                            <Input placeholder='请输入提货密码' onChange={(e) => {
                                this.setPassword(e)
                            }} />
                        </Form.Item>
                        <Form.Item
                            name='address'
                            label='收货地址'
                            rules={[{ required: true, message: '请填写收货地址' }]}
                        >
                             <TextArea placeholder='请输入收货地址' autoSize={{ minRows: 2, maxRows: 3 }} onChange={(e) => {
                                this.setAddress(e)
                            }} />
                        </Form.Item>
                        <Form.Item
                            name='person'
                            label='姓名'
                            rules={[{ required: true, message: '请填写姓名' }]}
                        >
                            <Input placeholder='请输入姓名' onChange={(e) => {
                                this.setPerson(e)
                            }} />
                        </Form.Item>
                        <Form.Item
                            name='phone'
                            label='手机号'
                            rules={[{ required: true, message: '请填写手机号' }]}
                        >
                            <Input placeholder='请输入手机号' onChange={(e) => {
                                this.setPhone(e)
                            }} />
                        </Form.Item>
                        <Form.Item
                            name='remark'
                            label='备注'
                        >
                            <Input onChange={(e) => {
                                this.setRemark(e)
                            }} />
                        </Form.Item>
                        <Form.Item
                            label='验证码'
                            name='verify'
                            rules={[{ required: true, message: '请填写验证码' }]}
                            extra={
                            <div className='extraPart'>
                                <img src={this.state.captcha} onClick={() => {
                                this.getCaptcha()
                            }}/>
                            </div>
                            }
                        >
                            <Input placeholder='请输入验证码' clearable onChange={(e) => {
                                this.setVerify(e)
                            }}/>
                        </Form.Item>
                    </>
                </Form>
                <Divider />
                <Space className='text20' style={{ 'font-weight': 'bold' }} onClick={() => {this.nextTo()}}>
                    查询物流单号
                </Space>
            </div>
        );
    }
}

export default Redeem;